import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "./contexts/CountryBrandApplicationContextProvider";
import {
	ApplicantCompanyInformationStep,
	AttachDocumentation,
	Certifications,
	CommonClassification,
	CompanyMemberships,
	ContactPersonStep,
	DataConfirmation,
	ExporterProfile,
	FactorsHallmarks,
	ImporterProfile,
	LegalRepresentative,
	MessageFormCompleted,
	OrganizationSite,
	PerformAccountingAudits,
	PolicyOfSustainability,
	StafHired,
	SustainabilityPractices,
	SustainabilityReporting,
} from "./steps";
import { UIEvents } from "./UIEvents";

const FORM_STEPS = [
	<ContactPersonStep />,
	<ApplicantCompanyInformationStep />,
	<LegalRepresentative />,
	<OrganizationSite />,
	<StafHired />,
	<AttachDocumentation />,
	<CommonClassification />,
	<ExporterProfile />,
	<ImporterProfile />,
	<PerformAccountingAudits />,
	<Certifications />,
	<CompanyMemberships />,
	<PolicyOfSustainability />,
	<SustainabilityReporting />,
	<SustainabilityPractices />,
	<FactorsHallmarks />,
	<DataConfirmation />,
	<MessageFormCompleted />,
];

function MultiStepForm() {
	const {
		currentStep,
		countryBrandApplication,
		setCurrentStep,
		previousStep,
		formRef,
		user,
		isLoading,
	} = useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const { isCompleted, id, uuid } = countryBrandApplication;

	function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
		event.preventDefault();
		document.dispatchEvent(new CustomEvent(UIEvents.builtInFormValidateSucess));
	}

	if (isLoading) {
		return (
			<div style={{ textAlign: "center" }}>
				<h3>Cargando...</h3>
			</div>
		);
	}

	if (uuid !== "new" && id === "-1") {
		return (
			<div style={{ textAlign: "center" }}>
				<h3>{`La solicitud ${uuid} no existe`}</h3>
				<a href="/">Volver al inicio</a>
			</div>
		);
	}

	return (
		<form ref={formRef} onSubmit={handleSubmit}>
			<fieldset disabled={isCompleted || user}>{FORM_STEPS[currentStep]}</fieldset>
			<div className="progress-container">
				<section className="progress">
					<div className="progress-buttons">
						{currentStep > 0 && (
							<button type="button" onClick={() => setCurrentStep(previousStep)}>
								ATRAS
							</button>
						)}

						{currentStep < FORM_STEPS.length - 1 && (
							<button type="submit">
								{currentStep === FORM_STEPS.length - 2 ? "FINALIZAR" : "SIGUIENTE"}
							</button>
						)}
					</div>

					{currentStep < FORM_STEPS.length - 1 && (
						<>
							<progress value={currentStep} max={FORM_STEPS.length - 1}></progress>
							<div className="progress-percent">{`${Math.round(
								(currentStep / (FORM_STEPS.length - 1)) * 100
							)}%`}</div>
						</>
					)}
				</section>
			</div>
		</form>
	);
}

export { MultiStepForm };
